import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Building2, Lock, Mail, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function AccountantLogin() {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        
        if (!email || !password) {
            toast.error('Veuillez remplir tous les champs');
            return;
        }
        
        setLoading(true);
        try {
            const res = await api.post('/auth/accountant-login', { email, password });
            
            // Store token
            localStorage.setItem('accountant_token', res.data.access_token);
            localStorage.setItem('accountant_company', res.data.accountant.owner_company_name);
            
            toast.success('Connexion réussie');
            window.location.href = '/accountant-dashboard';
        } catch (error) {
            console.error('Login error:', error);
            toast.error(error.response?.data?.detail || 'Identifiants invalides');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <div className="flex justify-center mb-4">
                        <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center">
                            <Building2 className="w-8 h-8 text-indigo-600" />
                        </div>
                    </div>
                    <CardTitle className="text-2xl">Espace Comptable</CardTitle>
                    <CardDescription>
                        Connectez-vous pour accéder aux factures de votre client
                    </CardDescription>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleLogin} className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="email">Email</Label>
                            <div className="relative">
                                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                                <Input
                                    id="email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="comptable@cabinet.fr"
                                    className="pl-10"
                                    disabled={loading}
                                />
                            </div>
                        </div>
                        
                        <div className="space-y-2">
                            <Label htmlFor="password">Mot de passe</Label>
                            <div className="relative">
                                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                                <Input
                                    id="password"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="••••••••"
                                    className="pl-10"
                                    disabled={loading}
                                />
                            </div>
                        </div>
                        
                        <Button type="submit" className="w-full" disabled={loading}>
                            {loading ? (
                                <>
                                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                    Connexion...
                                </>
                            ) : (
                                'Se connecter'
                            )}
                        </Button>
                    </form>
                    
                    <div className="mt-6 pt-6 border-t border-slate-100 text-center">
                        <p className="text-sm text-slate-500">
                            Cet accès vous a été fourni par votre client.
                        </p>
                        <p className="text-xs text-slate-400 mt-2">
                            Lecture seule • Données confidentielles
                        </p>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
